import { useDialogAction } from '@mews/framework';
import { useConfigureProductDialogForm } from '../components/ConfigureProductForm/useConfigureProductForm';
import { useEnterprisesProductContext } from '../context/EnterprisesProductContext';

export const useHandleAssignProperty = (id?: string) => {
    const { states, handlers } = useDialogAction(async () => Promise.resolve());
    const [renderConfigureProductDialog, toggleDialog] = useConfigureProductDialogForm();
    const { setState } = useEnterprisesProductContext();

    const handleConfirm = async () => {
        await handlers.handleConfirm();
        toggleDialog();
    };

    const handleAddToProperty = () => {
        handlers.handleOpen();
        if (id) {
            setState({
                centralProduct: {
                    id,
                },
                enterprises: [],
            });
        }
    };

    return { handleAddToProperty, handleConfirm, handlers, renderConfigureProductDialog, states };
};
